/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeADownIcon20Regular = forwardRef('ArrowShapeADownIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.411 17.772a2.25 2.25 0 0 0 3.18 0l6.977-6.967c.851-.85.249-2.305-.954-2.305H14.75V4a2 2 0 0 0-2-2h-5.5a2 2 0 0 0-2 2v4.5H2.388c-1.203 0-1.805 1.455-.954 2.305l6.977 6.967Zm2.12-1.061a.75.75 0 0 1-1.06 0L2.751 10H6a.75.75 0 0 0 .75-.75V4a.5.5 0 0 1 .5-.5h5.5a.5.5 0 0 1 .5.5v5.25c0 .414.335.75.75.75h3.251l-6.72 6.71Z" })));
});
